import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../Tenants";
import { TypePageActions } from "../Plans";
import { AddBtn } from "@/App/Sellers/Add";
import { TableData } from "@/App/Sellers/Table";
import { getSellersData, searchSellersData } from "@/Api/sellers";
import { useAuth } from "@/hooks/auth";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { UserCheck, UserPlus } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export type TableDataProps = {
  id: number;
  uuid: string;
  user_id: number;
  phone: string;
  document: string;
  is_active: number;
  created_at: string;
  address: {
    street: string;
    number: string;
    neighborhood: string;
    city: string;
    state: string;
  };
  unity: {
    id: string;
    name: string;
  };
  user: {
    id: number;
    roles: {
      id: number;
      name: string;
    }[];
    uuid: string;
    name: string;
    photo: string;
    email: string;
    user_type_id: number;
    tenant_id: number;
    is_active: number;
  };
};

export const PageList = () => {
  const [listData, setListData] = useState({} as ApiDataProps<TableDataProps>);
  const [state, setState] = useState("loading");
  const user = useAuth();
  const navigate = useNavigate();
  const unityId = user?.user?.unity?.[0]?.id || "";
  useEffect(() => {
    (async () => {
      const { data } = await getSellersData(1, unityId);
      setListData(data?.response);
      setState("production");
    })();
  }, []);
  const { hasPermission } = usePermissions();

  const pageActions: TypePageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        setState("loading");

        const { data } = await getSellersData(
          listData?.current_page + 1,
          unityId
        );
        setListData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        setState("loading");

        const { data } = await getSellersData(
          listData?.current_page - 1,
          unityId
        );
        setListData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        setState("loading");

        const { data } = await getSellersData(listData?.last_page, unityId);
        setListData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-sellers-list")}>
        <PageHeader
          icon={UserCheck}
          title="Vendedores"
          description="Gerencie sua equipe de vendas"
        >
          <If condition={hasPermission("view-employees-list")}>
            <Button
              variant="outline"
              onClick={() => navigate("/rh/colaboradores")}
            >
              <UserPlus className="h-4 w-4 mr-2" />
              Cadastro de Colaborador
            </Button>
          </If>
          <If condition={hasPermission("create-seller")}>
            <AddBtn updateFront={setListData} />
          </If>
        </PageHeader>
        <div className="flex flex-col gap-3">
          <SearchComponent
            updateFront={setListData}
            setState={setState}
            funcSearch={(params) =>
              searchSellersData({ ...params, unity_id: unityId })
            }
            placeholder="Pesquisar"
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={4} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={setListData}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
